import React, { useState, useEffect } from "react";
import { getCurrentLanguage, setCurrentLanguage } from "../core/_axios";

export enum Language {
    EN_US = "en-US",
    ES_ES = "es-ES",
    /*
    DE_DE = "de-DE",
    JA_JP = "ja-JP",
    FR_FR = "fr-FR",
    */
}

const LANGUAGE_LABELS: Record<Language, string> = {
    [Language.EN_US]: "English",
    [Language.ES_ES]: "Spanish",
    /*
    [Language.DE_DE]: "German",
    [Language.JA_JP]: "Japanese",
    [Language.FR_FR]: "French",
    */
};

const LANGUAGE_FLAGS: Record<Language, string> = {
    [Language.EN_US]: "/media/flags/united-states.svg",
    [Language.ES_ES]: "/media/flags/spain.svg",
    /*
    [Language.DE_DE]: "/media/flags/germany.svg",
    [Language.JA_JP]: "/media/flags/japan.svg",
    [Language.FR_FR]: "/media/flags/france.svg",
    */
};

const ENABLED_LANGUAGES: Language[] = [Language.EN_US, Language.ES_ES];

function LanguagePickerMenuItem() {
    const [language, setLanguage] = useState<Language>(Language.EN_US);

    useEffect(() => {
        const stored = getCurrentLanguage() as Language | null;
        if (stored && Object.values(Language).includes(stored)) {
            setLanguage(stored);
        }
    }, []);

    const handleChange = (lang: Language) => {
        if (lang !== language) {
            setCurrentLanguage(lang);
            setLanguage(lang);
            window.location.reload();
        }
    };

    return (
        <div
            className="menu-item"
            data-menu-item-offset="-10px, 0"
            data-menu-item-placement="left-start"
            data-menu-item-toggle="dropdown"
            data-menu-item-trigger="click|lg:hover"
        >
            <div className="menu-link">
                <span className="menu-icon">
                    <i className="ki-filled ki-icon"></i>
                </span>
                <span className="menu-title">Language</span>
                <div className="flex items-center gap-1.5 rounded-md border border-gray-300 text-gray-600 p-1.5 text-2xs font-medium shrink-0">
                    {LANGUAGE_LABELS[language]}
                    <img
                        alt=""
                        className="inline-block size-3.5 rounded-full"
                        src={LANGUAGE_FLAGS[language]}
                    />
                </div>
            </div>
            <div className="menu-dropdown menu-default light:border-gray-300 w-full max-w-[170px]">
                {ENABLED_LANGUAGES.map((lang) => (
                    <div
                        className={`menu-item${lang === language ? " active" : ""}`}
                        key={lang}
                    >
                        <a
                            className="menu-link h-10"
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                handleChange(lang);
                            }}
                        >
                            <span className="menu-icon">
                                <img
                                    alt=""
                                    className="inline-block size-4 rounded-full"
                                    src={LANGUAGE_FLAGS[lang]}
                                />
                            </span>
                            <span className="menu-title">{LANGUAGE_LABELS[lang]}</span>
                            {lang === language && (
                                <span className="menu-badge">
                                    <i className="ki-solid ki-check-circle text-success text-base"></i>
                                </span>
                            )}
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default LanguagePickerMenuItem;
